import { createSelector } from 'reselect';
import { createAction } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { Restriction } from '@mews-commander/data-access';
import { notEmpty } from '@mews-commander/utils';
import prefix from '../prefix';
import moduleSelector from '../selector';
import { createScopedEntitiesReducer, createScopedBaseEntitySelectors } from './utils';

export const NAME = 'restrictions';

const RESTRICTIONS_UPDATED = prefix('RESTRICTIONS_UPDATED');
const RESTRICTIONS_DELETED = prefix('RESTRICTIONS_DELETED');
const RESTRICTIONS_RESET = prefix('RESTRICTIONS_RESET');

export const updateRestrictionsState = (entities: Restriction[], scope: string) =>
    createAction(RESTRICTIONS_UPDATED, entities, { scope });

export const resetRestrictionState = (scope: string) => createAction(RESTRICTIONS_RESET, '', { scope });
export const deleteRestrictions = (ids: string[], scope: string) => createAction(RESTRICTIONS_DELETED, ids, { scope });

export const restrictionsReducer = createScopedEntitiesReducer({
    UPDATE_SUCCESS: RESTRICTIONS_UPDATED,
    DELETE_SUCCESS: RESTRICTIONS_DELETED,
    RESET_SUCCESS: RESTRICTIONS_RESET,
});

export const [getRestrictions, getRestrictionsByIds, getRestrictionByOwnerId, getRestriction] =
    createScopedBaseEntitySelectors<ApplicationState, Restriction, typeof NAME, 'serviceId'>(
        moduleSelector,
        NAME,
        'serviceId'
    );

export const existsRestriction = createSelector(getRestriction, notEmpty);
